import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeadphones: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconHeadphones"><Path d="M4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12V13H17.25C16.2835 13 15.5 13.7835 15.5 14.75V19.25C15.5 20.2165 16.2835 21 17.25 21H19.25C20.2165 21 21 20.2165 21 19.25V12C21 7.282 17.3696 3.41192 12.75 3.03081V3H12C7.02944 3 3 7.02944 3 12V19.25C3 20.2165 3.7835 21 4.75 21H6.75C7.7165 21 8.5 20.2165 8.5 19.25V14.75C8.5 13.7835 7.7165 13 6.75 13H4.5V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHeadphones;
